import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Layout from '../containers/Layout';
import Dashboard from '../components/Dashboard/index';
import Messages from '../components/Messages/index';
import { Rides } from '../components/Rides/index';


const routes = (
  <Route path="/" component={Layout}>
    <IndexRoute component={Dashboard} />
    <Route path="/messages" component={Messages} />
    <Route path="/rides" component={Rides} />
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./src/store/router.js